export default __webpack_public_path__ + "static/media/modelName.6ac763bf.png";